<template>
    <div class="mb-3">
        <div class="card">
            <div class="card-header bg-white">
                <h5 class="me-auto">Pagos</h5>
            </div>
            <div class="card-body p-0">
                <template>
                    <v-data-table :item-class="ITEM_ROW_BACKGROUND" class="elevation-1" :headers="headers" :loading="loading" :items="payments" hide-default-footer dense
                        :items-per-page="-1">
                        <template v-slot:[`item.efectivo`]="{ item }">
                            $ {{ Number(item.efectivo_usd || 0).toFixed(2) }} <br> ₡ {{
                                Number(item.efectivo || 0).toFixed(2) }}
                        </template>
                        <template v-slot:[`item.tarjeta`]="{ item }">
                            $ {{ Number(item.tarjeta_usd || 0).toFixed(2) }} <br> ₡ {{
                                Number(item.tarjeta || 0).toFixed(2) }}
                        </template>
                        <template v-slot:[`item.transferencia`]="{ item }">
                            $ {{ Number(item.transferencia_usd || 0).toFixed(2) }} <br> ₡ {{
                                Number(item.transferencia || 0).toFixed(2) }}
                        </template>
                        <template v-slot:[`item.sinpe_movil`]="{ item }">
                            ₡ {{ Number(item.sinpe_movil || 0).toFixed(2) }}
                        </template>
                    </v-data-table>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: true,
            id: this.$route.params.id,
            payments: [],
            headers: [
                { text: 'Efectivo', value: 'efectivo', sortable: false },
                { text: 'Tarjeta', value: 'tarjeta', sortable: false },
                { text: 'Transferencia', value: 'transferencia', sortable: false },
                { text: 'Sinpe movil', value: 'sinpe_movil', sortable: false },
            ],
        }
    },
    methods: {
        ITEM_ROW_BACKGROUND: function (item) {
            return 'green text-white'
        },
    },
    created() {
        let vue = this
        axios({ url: '/packages/' + vue.id + '/payments', method: 'GET' })
            .then((resp) => {
                vue.payments = resp.data
            })
            .catch((err) => {
                let message = err.response ? err.response.data.message : err.message
                vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
            })
            .finally((resp) => {
                vue.loading = false
            })
    }
}
</script>